export default __webpack_public_path__ + "static/media/credit-card.e4381632.svg";